module.exports = __webpack_public_path__ + "img/cars-2.b2f7787.webp";